<template>
  <div id="app">
    <header class="app-header">
      <div class="header-left">
        <a href="https://www.lausanne.ch" target="_blank">
        <img alt="Logo VdL" src="./assets/logos/Logo_VdLHorizontal.png" class="logo" /> 
        </a>
      </div>
      <nav class="main-nav">
        <router-link v-if="isAuthenticated" to="/home" :class="{ active: $route.path === '/home' }">
          <i class="bi bi-house-door-fill"></i> Accueil
        </router-link>
        <router-link v-if="isAuthenticated && referentialDisplay" to="/referential" :class="{ active: $route.path.includes('/referential') }">
          <i class="bi bi-list"></i> Référentiels
        </router-link>
        <!-- <router-link v-if="isAuthenticated && referentialDisplay" to="/referential/projectManagement" :class="{ active: $route.path.includes('/projectManagement') }">
          <i class="bi bi-folder-fill"></i> Gestion Projets
        </router-link> -->
        <router-link v-if="isAuthenticated" to="/project" :class="{ active: $route.path.includes('/project') &&  !$route.path.includes('projects/access')}">
          <i class="bi bi-folder-fill"></i> Projets
        </router-link>
        <router-link v-if="isAuthenticated && isAdmin" to="/users" :class="{ active: $route.path.includes('/users') }">
          <i class="bi bi-person-fill-gear"></i> Gestion administrateurs
        </router-link>
      </nav>
      <div class="user-menu">
        <template v-if="isAuthenticated">
          <div class="user-dropdown">
            <button class="avatar-button" @click="toggleDropdown" aria-label="Menu utilisateur" alt="menu utilisateur">
              <div class="avatar">
                <i class="bi bi-person"></i>
              </div>
              <span class="username-display">{{ truncateText(userInfo?.username, 25) || 'Inconnu' }}</span>
              <i class="bi bi-chevron-compact-down"></i>
            </button>
            <transition name="fade">
              <div class="dropdown-content" v-show="showDropdown">
                <router-link to="/modifyAccount" class="dropdown-item">
                  <i class="bi bi-person-fill"></i> Mon compte
                </router-link>
                <div v-if="referentialRights || isAdmin">
                  <a href="#" @click.prevent="handleFlush()" class="dropdown-item">
                    <i class="bi bi-arrow-clockwise"></i> Rafraîchir projets
                  </a>
                <!--   <a class="dropdown-item" @click.prevent="toggleAdminMode">
                    <i class="bi bi-shield-fill"></i> Admin
                  </a>--> 
                </div>
                <a href="#" @click.prevent="handleLogout()" id="logoutLink" class="dropdown-item">
                  <i class="bi bi-box-arrow-left"></i> Déconnecter
                </a>
              </div>
            </transition>
          </div> 
        </template>
      </div>
    </header>
    <div v-if="isAuthenticated" class="third-nav-container">
      <ProjectHeader v-if="selectedProject > 0 && $route.params.id > 0"></ProjectHeader>
      <ReferentialHeader v-if="selectedReferential > 0  && $route.params.id > 0"></ReferentialHeader>
    </div>
    <div v-if="isAuthenticated" class="secondary-nav-container">
      <div v-if="selectedReferential && $route.path.includes('/referential')" class="second-nav-bar">
        <router-link :to="`/referential/${selectedReferential}/generalDataConfig`" 
          :class="{ active: $route.path === `/referential/${selectedReferential}/generalDataConfig` }">
          <i class="bi bi-gear-fill"></i> Données générales
        </router-link>
        <router-link :to="`/referential/${selectedReferential}/database`" 
          :class="{ active: $route.path === `/referential/${selectedReferential}/database` }">
          <i class="bi bi-database-fill"></i> Base de données
        </router-link>
        <router-link :to="`/referential/${selectedReferential}`" 
          :class="{ active: $route.path === `/referential/${selectedReferential}` }">
          <i class="bi bi-bar-chart-steps"></i> Questions durabilité
        </router-link>
        <router-link v-if="(isReferentialOwner || isAdmin) && selectedReferential" :to="`/referential/${selectedReferential}/access`" 
          :class="{ active: $route.path === `/referential/${selectedReferential}/access` }">
          <i class="bi bi-person-fill-gear"></i> Gestion rôles
        </router-link>
        <router-link v-if="(referentialRights && selectedReferential) && totalProjectsForNav" :to="`/referential/${selectedReferential}/projects/access`" 
          :class="{ active: $route.path === `/referential/${selectedReferential}/projects/access` }">
          <i class="bi bi-files"></i> Gestion projets
        </router-link>
      </div>
      
      <div v-if="selectedProject && $route.path.includes('/project')" class="second-nav-bar">
        <!-- <router-link :to="`/project/${selectedProject}`" 
          :class="{ active: $route.path === `/project/${selectedProject}` }">
          <i class="bi bi-folder2-open"></i> {{ currentProjectTitle.length > 25 ? currentProjectTitle.slice (0,25) : currentProjectTitle }}
        </router-link> -->
        <router-link :to="`/project/${selectedProject}/generalData`" 
            :class="{ active: $route.path === `/project/${selectedProject}/generalData` }">
            <i class="bi bi-gear-fill"></i> Données générales
        </router-link>
        <router-link :to="`/project/${selectedProject}`" 
        :class="{ active: $route.path === `/project/${selectedProject}` }">
        <i class="bi bi-bar-chart-steps"></i> Analyse durabilité
      </router-link>
      <router-link v-if="hasGraph" :to="`/project/${selectedProject}/charts`" 
        :class="{ active: $route.path === `/project/${selectedProject}/charts` }">
        <i class="bi bi-pie-chart-fill"></i> Graphiques
      </router-link>
      <router-link v-if="selectedProject && filterActiveProject?.PC" :to="`/project/${selectedProject}/shareCode`" 
          :class="{ active: $route.path === `/project/${selectedProject}/shareCode` }">
          <i class="bi bi-share-fill"></i> Partage projet
      </router-link>
      <router-link v-if="selectedProject && (filterActiveProject?.PC || filterActiveProject?.PE || isAdmin)" :to="`/project/${selectedProject}/evaluation`" 
          :class="{ active: $route.path === `/project/${selectedProject}/evaluation` }">
          <i class="bi bi-reply-all-fill"></i> Suivi évaluation
      </router-link>

      <!-- <router-link v-if="isAdmin || roles" :to="`/project/${selectedProject}/access`" 
          :class="{ active: $route.path === `/project/${selectedProject}/access` }">
          <i class="bi bi-person-fill-gear"></i> Gestion des rôles
      </router-link> -->
      <!-- <router-link :to="`/project/${selectedProject}`" 
        :class="{ active: $route.path === `/project/${selectedProject}` }">
        <i class="bi bi-folder2-open"></i> {{ currentProjectTitle.length > 25 ? currentProjectTitle.slice (0,25) : currentProjectTitle }}
      </router-link> -->
      </div>
    </div>
    
    <div class="content-container">
      <!-- <Breadcrumb v-if="isAuthenticated" /> -->
      <main class="main-content">
        <router-view></router-view>
        <ArrowVue></ArrowVue>
        <LoadingOverlay v-if="loading"/>
      </main>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
//import Breadcrumb from './components/generic/TemplateBreadcrumb.vue'
import ProjectHeader from './components/generic/ProjectHeader.vue'
import LoadingOverlay from './components/generic/LoadingOverlay.vue';
import ReferentialHeader from './components/generic/ReferentialHeader.vue'
import ArrowVue from './components/auth/ArrowVue.vue';

export default {
  name: "App",
  data() {
    return {
      showDropdown: false,
      currentYear: new Date().getFullYear(),
      /* adminModeActive: false */
    }
  },
  components: {
  //  Breadcrumb,
    ProjectHeader,
    ReferentialHeader,
    ArrowVue,
    LoadingOverlay
  },
  computed: {
    ...mapState('auth', ['isAuthenticated', 'user', 'isAdmin', 'referentialDisplay', 'respStatus', 'user_id', 'userInfo', 'loading']),
    ...mapState('referential', ['selectedReferential', 'referentialData', 'projectStatusByReferential', 'loading']),
    ...mapState('project', ['selectedProject', 'roles', 'filterActiveProject', 'projectData', 'projectValues']),
    ...mapGetters('referential', ['truncateText', 'getProjectsInValidationList', 'getProjectsBackInEditionList' , 'getProjectsValidatedList', /* 'getProjectsAfterValidationList', */ 'getProjectsInArchivedList']),
    ...mapGetters('project', ['filterActiveProject']),
    
    referentialRights(){
      const id = this.selectedReferential || 0;
      if (!id) return false;
      const ref = this.referentialData.find(r => r?.referentiel_id === id);
      //console.log("numberProjects,referentialRights : ",ref, "\tthis.referentialData :",this.referentialData )
      if(!ref)return false;
      
      return !!(ref && (ref.RC || this.isAdmin));
    },


    totalProjectsForNav() {
      const a = this.getProjectsInValidationList?.length || 0;
      const b = this.getProjectsValidatedList?.length || 0;
      const c = this.getProjectsBackInEditionList?.length || 0;
      const d = this.getProjectsInArchivedList?.length || 0;
      /* const e = Array.isArray(this.getProjectsAfterValidationList)
        ? this.getProjectsAfterValidationList.length
        : Object.values(this.getProjectsAfterValidationList || {}).flat().length || 0; */
      //console.log(a + b + c + d + " : total numberProjects,")
      return a + b + c + d /* + e */;
    },
    
    currentReferentialTitle() {
      if (!this.selectedReferential) return null;
      
      const ref = this.referentialData.find(
        r => r.referentiel_id === this.selectedReferential
      );
      if (ref) return ref.title;
      this.$store.dispatch('referential/fetchReferentialList');
      return "Chargement...";
    },
    
    //Id undefined when refreshing from non admin in generalDataConfig ?
    isReferentialOwner() {
      if (!this.selectedReferential) return false;
      const referential = this.referentialData.find(r => r.referentiel_id === this.selectedReferential)
      //console.log("Referential data:", referential)
      if (!referential) return false;
      if(referential.RC) {
        return true
      }
      return false
    },
    hasGraph(){
      if (!this.selectedProject || !this.projectValues || this.projectValues.length === 0) {
        return false;
      }
      //console.log("this.projectValues :", this.projectValues)
      return this.projectValues.show_graphs === true;
    },
    /* currentProjectTitle() {
      if (!this.selectedProject) return null;
      
      const project = this.$store.state.project.projectData.find(
        p => p.project_id === this.selectedProject
      );
      if (project) return project.title.length > 25 ? project.title.slice(0, 25) + '…' : project.title;
      return "Chargement...";
    } */
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async handleLogout() {
      this.showDropdown = false;
      await this.logout();
      this.$router.push('/login');
    },
    handleFlush(){
      if(this.isAdmin){
        this.$store.dispatch("project/flushProjectsAdmin");
      }else{
        //console.log("flush : this.$route.params.id:", this.$route.params.id, "\nselectedReferential : ", this.selectedReferential)
        this.$store.dispatch("referential/flushProjects", {id : this.selectedReferential ? this.selectedReferential : this.$route.params.id });
      }
    this.$store.commit('project/clearProjectState', null, { root: true })
    this.$store.commit('referential/clearReferentialState', null, { root: true })
    this.$router.push('/');
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    /* toggleAdminMode() {
      this.adminModeActive = !this.adminModeActive;
    }, */
    closeDropdown(e) {
      if (!this.$el.querySelector('.user-dropdown')?.contains(e.target)) {
        this.showDropdown = false;
      }
    },
    /* loadReferentialIfNeeded() {
    const routePath = this.$route.path;
    const match = routePath.match(/\/referential\/(\d+)/);
    
    if (match && match[1]) {
      const referentialId = parseInt(match[1]);
      this.$store.dispatch("referential/fetchReferentialList")
        .then(() => {
          if (referentialId) {
            this.$store.commit("referential/selectTreeMutation", referentialId);
            if (!routePath.includes('/database') && !routePath.includes('/generalDataConfig')) {
              this.$store.dispatch("referential/fetchCriteriaListFromReferential", { id: referentialId });
            }
          }
        })
        .catch(error => console.error("Error fetching referential data:", error));
    }
  } */
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
    this.$store.dispatch('auth/checkAuth')
    //console.log('User authenticated:', this.isAuthenticated)
    //console.log('User info:', this.user)
    //console.log("Is Admin:", this.isAdmin)
    //console.log("project Data:", this.filterActiveProject )
    /* this.loadReferentialIfNeeded(); */
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdown);
  },
  watch: {
    '$route'(to) {
      // Check if we're on a referential route
      const match = to.path.match(/\/referential\/(\d+)/);
      if (match && match[1]) {
        const referentialId = parseInt(match[1]);
        this.$store.commit("referential/selectTreeMutation", referentialId);
      }
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,500,600,700,800,300i,400i,500i,600i,700i,800i&display=swap');
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css");


/* Header styles */
.app-header {
  background: var(--bg-color);
  box-shadow: var(--shadow-light);
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  position: static; /* sticky if needed */
  top: 0;
  /* z-index: 99; */
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  height: auto;
  width: 250px;
}

/* Navigation styles */

.main-nav {
  display: flex;
  gap: 1rem;
  flex-grow: 1;
  justify-content: center;
}

.secondary-nav-container {
  width: 100%;
  position: static; /* sticky if needed */
  top: 70px;
  /* z-index: 99; Might need to activate it if it's needed */
}

.third-nav-container{
  width: 100%;
  position: static;
  /* z-index: 99; */
}

.second-nav-bar {
  display: flex;
  justify-content: center;
  width: 100%;
  background: var(--bg-color);
  padding: 0.5rem 0;
  box-shadow: var(--shadow-light);
  margin-bottom: 1rem;
  gap: 0.5rem;
}

.main-nav a, .second-nav-bar a {
  color: var(--text-color);
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius);
  transition: var(--transition);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  /* font: var(--secondary-font); */
  font-weight: 600;
}

.main-nav a:hover, .second-nav-bar a:hover {
  color: var(--primary-color);
  background: var(--primary-light);
}

.main-nav a.active, .second-nav-bar a.active {
  color: var(--primary-color);
  background: var(--primary-light);
  font-weight: 600;
}

/*  menu styles */
.user-menu, .user-dropdown {
  position: relative;
}

.avatar-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: var(--border-radius);
  transition: var(--transition);
}

.avatar-button:hover {
  background: var(--primary-light);
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.admin-theme {
  --primary-color: #4285F4;
  --primary-light: rgba(66, 133, 244, 0.1);
  --hover-bg: #f8f9fa; /* Inchangé */
  --left2-color: #4285F4b3;
  --left3-color: #4285F481;
  --left4-color: #4285F435;
  --question-color: #e4f2fd9c;
}
.username-display {
  /* font: var(--secondary-font); */
  font-weight: bold;
  color: var(--text-color);
  display: block;
}

.dropdown-content {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 0.5rem;
  background-color: var(--bg-color);
  min-width: 220px;
  box-shadow: var(--shadow-medium);
  border-radius: var(--border-radius);
  overflow: hidden;
  z-index:104;
}

.dropdown-item {
  color: var(--text-color);
  padding: 0.75rem 1rem;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: var(--transition);
}

.dropdown-item:hover{
  background-color: var(--primary-light);
  color: var(--text-color);
}

.main-nav i {
  font-size: 1rem;
}


/* Auth buttons */
.auth-buttons {
  display: flex;
  gap: 0.5rem;
}

.auth-button {
  padding: 0.5rem 1rem;
  background: var(--bg-color);
  border: 1px solid var(--primary-color);
  border-radius: var(--border-radius);
  color: var(--primary-color);
  text-decoration: none;
  transition: var(--transition);
  font-weight: 500;
}

.auth-button:hover {
  background: var(--primary-color);
  color: var(--bg-color);
}

button:hover {
  color: var(--text-color);
}

/* Content container */
.content-container {
  flex: 1;
  padding: 1.5rem;
  /* max-width: 1520px; */
  margin: 0 auto;
  width: 90%;
  position: sticky;
}

.current-referential {
  background: var(--bg-color);
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-light);
}

.current-referential h1 {
  color: var(--primary-color);
  font-size: 1.5rem;
  font-weight: 600;
}

.main-content {
  background: var(--bg-color);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-light);
  padding: 1.5rem;
  margin-top: 2vh;
}

/* Footer */
.app-footer {
  background: var(--bg-color);
  padding: 1rem;
  text-align: center;
  color: var(--text-color);
  border-top: 1px solid var(--border-color);
  margin-top: 2rem;
}

/* Animations */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.bi-person {
  font-size: 1.7rem;
  text-align: center;
}

.bi-reply-all-fill{
  transform : rotateY(180deg);
}

.app{
  max-width: 1520px;
}

</style>